import api from '../../../../api';

export const QuoteSelector = {
  QUOTE: api.internals.ns.selector('quote')
};
